















import { Vue, Component } from 'vue-property-decorator';

import { getProfile, loadFacebookAuth } from '~/plugins/social/facebook';

@Component
export default class FacebookLoginButton extends Vue {
  /*
    This method starts the facebook process, initiate the popup and will trigger
    this.onAuthLoaded if user is accepted on facebook's side
  */
  async facebookConnect () {
    try {
      const auth = await loadFacebookAuth(String(this.$config.FACEBOOK_APP_ID));
      this.$social.rememberProvider("facebook");
      await this.onAuthLoaded(auth);
    } catch (error) {
      const closedByUser = error === "unknown";
      if (!closedByUser) {
        // Something went wrong on facebook's end.
        this.$emit("error", error);
      }
    }
  }

  /*
    This method handle the response from facebook api, and allows to sign in or
    not the user
  */
  async onAuthLoaded (auth: Types.FacebookAuth) {
    // Try to connect with the API
    const signInPayload: Types.SignInSocialPayload = {
      provider: "facebook",
      body: {
        social_token: auth?.accessToken,
        social_user_id: auth?.userID,
      },
    };
    const apiError = await this.$store.dispatch('user/signinWithSocial', signInPayload);
    if (!apiError) {
      // The API call has suceeded, which means the user was already known and
      // is now authenticated. Skip the signup entirely.
      return this.$emit("signed-in");
    }

    // Retrieve user's info from facebook and store them for next step
    const facebookProfile = await getProfile();

    const userInfo: Types.SocialUserInfo = {
      provider: "facebook",
      ...signInPayload.body,
      email: facebookProfile.email || "",
      firstname: facebookProfile.first_name || "",
      lastname: facebookProfile.last_name || "",
    };
    return this.$emit("need-signup", userInfo);
  }
}
